const cardItems = [
  { label: 'CSSBuy Review', icon: 'ri-shopping-bag-line', href: '/cssbuy-deep-review' },
  { label: 'KakoBuy Review', icon: 'ri-smartphone-line', href: '/kakobuy-deep-review' },
  { label: 'Superbuy Review', icon: 'ri-global-line', href: '/superbuy-deep-review' },
  { label: 'Agent Compare', icon: 'ri-scales-line', href: '/cssbuy-vs-kakobuy' },
  { label: 'Budget Picks', icon: 'ri-money-dollar-circle-line', href: '/cheap-spreadsheet-sneakers-2026' },
];

export default function ArticleHub() {
  return (
    <section className="bg-foreground-950 px-6 md:px-10 lg:px-16 py-20 md:py-28">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-foreground-400 text-xs tracking-[0.25em] uppercase font-light mb-6">
          CSSBuy Editorial
        </p>

        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 font-semibold leading-tight mb-10">
          The Spreadsheet<br />
          Shopping Revolution<br />
          Is Here
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="/cssbuy-spreadsheet-guide-2026"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-900 text-sm font-semibold rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Read SEO Articles
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 border border-background-50/30 text-background-50 text-sm font-semibold rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Visit Main Store
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {cardItems.map((item, idx) => (
            <a
              key={idx}
              href={item.href}
              className="bg-foreground-900 rounded-xl p-5 flex flex-col items-center text-center gap-3 transition-all duration-300 hover:bg-foreground-800 cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-background-50 text-xl group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              <span className="text-background-50 text-xs font-medium">{item.label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}